import React, { useState, useEffect } from 'react';
import config from '../../config/apiConfig';
import { imprimirReporteZ } from '../../services/Impresion';
import { hoyChile, jornadaChile } from '../../services/utils';

const ReporteCuadratura = () => {
    const getHoyFormato = hoyChile;

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // NUEVOS ESTADOS PARA LOS FILTROS
    const [fechaInicio, setFechaInicio] = useState(getHoyFormato());
    const [fechaFin, setFechaFin] = useState(getHoyFormato());
    const [turnos, setTurnos] = useState([]);
    const [turnoId, setTurnoId] = useState('');

    // La función cargarReporte ahora usa las fechas del estado
    const cargarReporte = async function () {
        try {
            setLoading(true);
            setError(null); // Limpiar errores pasados
            const token = localStorage.getItem("token");
            if (!token) throw new Error("No se encontró token de sesión.");

            // Agregamos los parámetros a la URL
            let url = `${config.api_url}/api/reportes/cuadratura_completa?inicio=${fechaInicio}&fin=${fechaFin}`;
            if (turnoId) url += `&turno_id=${turnoId}`;

            const res = await fetch(url, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'token': token }
            });

            if (!res.ok) throw new Error("Error al obtener datos de la API.");
            const json = await res.json();
            setData(json);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Carga la lista de turnos configurados (si no hay ninguno, el selector
    // simplemente no aparece y nada cambia en el reporte).
    const cargarTurnos = async function () {
        try {
            const token = localStorage.getItem("token");
            const res = await fetch(`${config.api_url}/configuracion/turnos/`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'token': token }
            });
            const json = await res.json();
            if (json.completado) setTurnos(json.turnos || []);
        } catch (err) {
            // silencioso -- si falla, simplemente no hay selector de turno
        }
    };

    // Al montar el componente, carga el reporte de "hoy"
    useEffect(() => {
        cargarReporte();
        cargarTurnos();
    }, []);

    // Al elegir un turno, paramos las fechas en la jornada en curso de ese
    // turno. Importa para los turnos que cruzan medianoche: a la 01:00, la
    // jornada vigente es la de ayer, y sin esto el cajero que cierra caja
    // veía el reporte vacío por quedarse en el día calendario nuevo.
    const handleTurnoChange = (e) => {
        const nuevoId = e.target.value;
        setTurnoId(nuevoId);

        if (!nuevoId) {
            setFechaInicio(getHoyFormato());
            setFechaFin(getHoyFormato());
            return;
        }
        const turno = turnos.find((t) => String(t.id) === String(nuevoId));
        if (!turno) return;
        const jornada = jornadaChile(turno.hora_inicio, turno.hora_fin);
        setFechaInicio(jornada);
        setFechaFin(jornada);
    };

    const handleFiltrar = (e) => {
        e.preventDefault();
        cargarReporte(); // Vuelve a cargar usando las fechas seleccionadas
    };

    const handleImpresionZ = async function () {
        if (!data) return;

        const resumen = data.resumen_tabla || [];
        const cuadros = data.cuadros_resumen || {};
        const ranking = data.ranking_productos || [];
        const usuarios = data.ventas_por_usuario || [];

        try {
            await imprimirReporteZ(data, resumen, cuadros, ranking, usuarios);
            alert("🖨️ Reporte enviado a la impresora.");
        } catch (e) {
            alert("❌ Error al enviar la impresión.");
        }
    };

    const formatCur = function (val) {
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 }).format(Number(val) || 0);
    };

    const getEstiloMedio = function (medio) {
        var m = (medio || "").toUpperCase();
        if (m.indexOf('UBER') !== -1) return { color: '#06C167', icon: '🚗' };
        if (m.indexOf('PEDIDOS') !== -1) return { color: '#E21247', icon: '🔴' };
        if (m.indexOf('TRANSFERENCIA') !== -1) return { color: '#00B4D8', icon: '🏦' };
        if (m.indexOf('EFECTIVO') !== -1) return { color: '#28a745', icon: '💵' };
        return { color: '#495057', icon: '📦' };
    };

    return (
        <div style={{ backgroundColor: '#f4f6f9', minHeight: '100vh', width: '100%', paddingBottom: '3rem' }}>
            <div className="container py-4" style={{ maxWidth: '800px' }}>
                {/* NUEVA BARRA DE FILTROS */}
                <div className="card shadow-sm border-0 mb-3" style={{ borderRadius: '10px' }}>
                    <div className="card-body p-3">
                        <form onSubmit={handleFiltrar} className="row align-items-end">
                            <div className="col-md-5 mb-2 mb-md-0">
                                <label className="small font-weight-bold text-muted mb-1">Desde</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={fechaInicio}
                                    onChange={(e) => setFechaInicio(e.target.value)}
                                    max={fechaFin} // No dejar elegir inicio mayor que fin
                                />
                            </div>
                            <div className="col-md-5 mb-2 mb-md-0">
                                <label className="small font-weight-bold text-muted mb-1">Hasta</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={fechaFin}
                                    onChange={(e) => setFechaFin(e.target.value)}
                                    min={fechaInicio} // No dejar elegir fin menor que inicio
                                />
                            </div>
                            {turnos.length > 0 &&
                                <div className="col-md-3 mb-2 mb-md-0">
                                    <label className="small font-weight-bold text-muted mb-1">Turno</label>
                                    <select className="form-control" value={turnoId} onChange={handleTurnoChange}>
                                        <option value="">Todos</option>
                                        {turnos.map((t) => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                                    </select>
                                </div>
                            }
                            <div className="col-md-2">
                                <button type="submit" className="btn btn-primary btn-block font-weight-bold" disabled={loading}>
                                    {loading ? '...' : 'Filtrar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                {loading && <div className="text-center mt-5"><div className="spinner-border text-primary"></div></div>}
                {error && <div className="alert alert-danger m-5">{error}</div>}

                {(!loading && !error && data) && (
                    <div className="card shadow-lg border-0" style={{ borderRadius: '15px', overflow: 'hidden' }}>

                        {/* CABECERA */}
                        <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center py-3">
                            <h4 className="mb-0 font-weight-bold">CUADRATURA</h4>
                            <div className="text-right">
                                <span className="badge badge-warning px-3 py-1">{data.total_pedidos_dia ? data.total_pedidos_dia : 0} Pedidos</span>
                                <div className="small text-muted">{data.fecha}</div>
                            </div>
                        </div>

                        <div className="card-body p-0">
                            {/* TABLA 1: MEDIOS DE PAGO */}
                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead className="bg-light text-uppercase small">
                                        <tr>
                                            <th>Medio de Pago</th>
                                            <th className="text-center">Cant.</th>
                                            <th className="text-right">Bruto Total</th>
                                            <th className="text-right text-primary">Caja/Banco</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(data.resumen_tabla || []).map(function (item, i) {
                                            var estilo = getEstiloMedio(item.medio);
                                            return (
                                                <tr key={i}>
                                                    <td className="align-middle font-weight-bold" style={{ color: estilo.color }}>
                                                        <span className="mr-2">{estilo.icon}</span> {item.medio}
                                                        {Number(item.monto_pendiente) > 0 && (
                                                            <small className="d-block text-warning font-weight-bold">
                                                                Pendiente: {formatCur(item.monto_pendiente)}
                                                            </small>
                                                        )}
                                                    </td>
                                                    <td className="text-center align-middle">{item.cantidad}</td>
                                                    <td className="text-right align-middle text-muted">{formatCur(item.monto_total)}</td>
                                                    <td className="text-right align-middle font-weight-bold text-success">
                                                        {formatCur(item.monto_en_caja)}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* BANNER TOTAL VENTAS */}
                            <div className="bg-primary text-white p-3 d-flex justify-content-between align-items-center">
                                <h4 className="mb-0 font-weight-bold text-uppercase small">Ventas Totales Brutas:</h4>
                                <h2 className="mb-0 font-weight-bold">{formatCur(data.cuadros_resumen ? data.cuadros_resumen.total_ventas : 0)}</h2>
                            </div>

                            {/* VENTAS POR USUARIO */}
                            <div className="p-4 bg-white border-bottom">
                                <h6 className="font-weight-bold text-uppercase small mb-3 text-muted">
                                    <i className="fas fa-chart-line mr-2"></i> Ventas por Usuario / Canal
                                </h6>
                                {(!data.ventas_por_usuario || data.ventas_por_usuario.length === 0) ? (
                                    <div className="text-muted small">No hay registros de usuarios en este periodo.</div>
                                ) : (
                                    <div className="row">
                                        {data.ventas_por_usuario.map(function (u, idx) {
                                            return (
                                                <div key={idx} className="col-12 mb-2">
                                                    <div className={`d-flex justify-content-between align-items-center p-2 border rounded ${u.es_web ? 'border-primary' : 'bg-light'}`}>
                                                        <div>
                                                            <span className={`font-weight-bold ${u.es_web ? 'text-primary' : 'text-dark'}`}>
                                                                {u.nombre_usuario}
                                                            </span>
                                                            <small className="text-muted d-block">{u.cantidad_pedidos} pedidos realizados</small>
                                                        </div>
                                                        <div className="text-right">
                                                            <span className={`h6 mb-0 font-weight-bold ${u.es_web ? 'text-primary' : 'text-dark'}`}>
                                                                {formatCur(u.total_vendido)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>

                            {/* VENTAS POR CAJA */}
                            {data.ventas_por_caja && data.ventas_por_caja.length > 0 && (
                                <div className="p-4 bg-white border-bottom">
                                    <h6 className="font-weight-bold text-uppercase small mb-3 text-muted">
                                        <i className="fas fa-cash-register mr-2"></i> Ventas por Caja / Terminal
                                    </h6>
                                    {data.ventas_por_caja.map(function (c, idx) {
                                        return (
                                            <div key={idx} className="d-flex justify-content-between align-items-center p-2 border rounded mb-2 bg-light">
                                                <div>
                                                    <span className="font-weight-bold text-dark">
                                                        <i className="fas fa-desktop text-muted mr-2"></i>{c.caja}
                                                    </span>
                                                    <small className="text-muted d-block">{c.total_pedidos} pedidos</small>
                                                </div>
                                                <span className="h6 mb-0 font-weight-bold text-success">{formatCur(c.total_ventas)}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {/* SECCIÓN NUEVA: VENTAS POR MESA */}
                            <div className="p-4 bg-white border-bottom">
                                <h6 className="font-weight-bold text-uppercase small mb-3 text-muted">
                                    <i className="fas fa-chair mr-2"></i> Ingresos por Mesas
                                </h6>
                                {data.ventas_por_mesa.map((m, idx) => (
                                    <div key={idx} className="d-flex justify-content-between mb-1">
                                        <span>{m.nombre} ({m.pedidos} ped.)</span>
                                        <span className="font-weight-bold">{formatCur(m.total)}</span>
                                    </div>
                                ))}
                            </div>

                            {/* CUADROS RESUMEN EFECTIVO/BANCO */}
                            <div className="row no-gutters text-center border-bottom bg-white">
                                <div className="col-4 p-4 border-right">
                                    <small className="text-muted font-weight-bold d-block mb-1 text-uppercase">Efectivo Real en Caja</small>
                                    <h3 className="text-danger font-weight-bold mb-0">{formatCur(data.cuadros_resumen ? data.cuadros_resumen.efectivo_caja : 0)}</h3>
                                </div>
                                <div className="col-4 p-4">
                                    <small className="text-muted font-weight-bold d-block mb-1 text-uppercase">Transferencias / Tarjetas / Banco</small>
                                    <h3 className="text-info font-weight-bold mb-0">{formatCur(data.cuadros_resumen ? data.cuadros_resumen.transferencias_banco : 0)}</h3>
                                </div>
                                <div className="col-4 p-4 border-right">
                                    <small className="text-muted font-weight-bold d-block mb-1 text-uppercase">Total Propinas</small>
                                    <h3 className="text-success font-weight-bold mb-0">{formatCur(data.cuadros_resumen.total_propinas)}</h3>
                                </div>
                            </div>

                            {/* RANKING PRODUCTOS */}
                            <div className="p-4 bg-light text-dark">
                                <h6 className="font-weight-bold text-uppercase small mb-3 text-muted">Top 5 Productos más Vendidos</h6>
                                {(!data.ranking_productos || data.ranking_productos.length === 0) ? (
                                    <div className="text-muted small">No hay productos vendidos en este periodo.</div>
                                ) : (
                                    data.ranking_productos.map(function (p, idx) {
                                        return (
                                            <div key={idx} className="d-flex justify-content-between py-2 border-bottom border-white">
                                                <span className="text-secondary font-weight-bold">{idx + 1}. {p.producto}</span>
                                                <span className="badge badge-dark badge-pill px-3 align-self-center">{p.cantidad} unidades</span>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>

                        {/* BOTÓN IMPRESIÓN */}
                        <div className="card-footer bg-white text-center p-4">
                            <button className="btn btn-dark btn-lg px-5 font-weight-bold shadow-sm" onClick={handleImpresionZ}>
                                <i className="fas fa-print mr-2"></i> IMPRIMIR REPORTE
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReporteCuadratura;